import { render, staticRenderFns } from "./podcast-filter-app.vue?vue&type=template&id=36357344&"
import script from "./podcast-filter-app.vue?vue&type=script&lang=js&"
export * from "./podcast-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('36357344', component.options)
    } else {
      api.reload('36357344', component.options)
    }
    module.hot.accept("./podcast-filter-app.vue?vue&type=template&id=36357344&", function () {
      api.rerender('36357344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/containers/podcast-filter-app.vue"
export default component.exports